module.exports = __webpack_public_path__ + "Icono_Hist.CotizacionesMenu_126px.png";